import MyHeader from '../../components/header';
import MyFooter from '../../components/footer';
import { auth, db } from '../../firebase';

import Spacer from '../../components/spacer';
import { Form, Link, useLoaderData, useNavigate } from 'react-router-dom';
import l from './a.module.scss';
import { useEffect } from 'react';
import { getValFrmDict, sdgs, slug } from '../../../k4dAdmin/data';

import { truncateForLink } from '../../data';

export default function TermsOfUse() {
  return (
    <>
      <MyHeader />
      <div className={l.whole0}>
        <div className={l.whole}>
          <div className={l.co}>
            <Spacer />
            <h1>Terms Of Use</h1>

            <p>
              knowledge for development provides researchers the opportunity to share their findings for sustainable
              development and growth. This medium recognizes and respects the right of participation of rural
              communities in their sustainable development. The benefits resulting from any scientific research and its
              applications to our daily lives and society as a whole are necessary for development. Through the
              presentation of abstracts written in lay and rural languages that members of the non-scientific
              communities would understand, the Lifestyle Research Entity of the North West University utilized this
              medium to reach our different researched communities. The levels of vulnerability of participants
              resulting from low literacy and poverty levels are quite grievous. We are not oblivious to the fact that
              the reception, understanding, and utilization of research information is influenced by the social
              inequalities of the participants, hence the need to share the information with them. The importance of
              this within the principles of moral and social justice cannot be over-emphasized in all rural and
              developing communities.
            </p>
          </div>
          <MyFooter />
        </div>
      </div>
    </>
  );
}
